import React from "react";
import { Download, Eye, FileText } from "lucide-react";

interface FileViewerProps {
  fileName: string;
  fileUrl: string;
  description?: string;
  uploadDate?: string;
  fileSize?: number;
  showFileInfo?: boolean;
}

/**
 * Reusable file viewer component
 * Provides consistent file viewing and downloading interface
 */
const FileViewer: React.FC<FileViewerProps> = ({
  fileName,
  fileUrl,
  description,
  uploadDate,
  fileSize,
  showFileInfo = true,
}) => {
  const formatFileSize = (bytes: number): string => {
    return `${(bytes / 1024 / 1024).toFixed(1)}MB`;
  };

  return (
    <div className="text-center py-8">
      <FileText className="w-16 h-16 text-gray-400 mx-auto mb-4" />
      <h4 className="text-lg font-semibold text-gray-900 mb-2">{fileName}</h4>
      {description && <p className="text-gray-600 mb-4">{description}</p>}
      {showFileInfo && (uploadDate || fileSize) && (
        <p className="text-sm text-gray-500 mb-4">
          {uploadDate && `업로드일: ${uploadDate}`}
          {uploadDate && fileSize && " • "}
          {fileSize && `크기: ${formatFileSize(fileSize)}`}
        </p>
      )}
      <p className="text-gray-600 mb-4">
        파일을 다운로드하거나 새 탭에서 열어보세요
      </p>
      <div className="flex gap-3 justify-center">
        <a
          href={fileUrl}
          download
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Download className="w-4 h-4" />
          <span>다운로드</span>
        </a>
        <a
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <Eye className="w-4 h-4" />
          <span>새 탭에서 보기</span>
        </a>
      </div>
    </div>
  );
};

export default FileViewer;
